import { Component, input, output } from '@angular/core';

import { QaiIconComponent, QaiIconKind } from '@qai/ui';

@Component({
  selector: 'simulation-type-option',
  standalone: true,
  templateUrl: './simulation-type-option.component.html',
  styleUrls: ['./simulation-type-option.component.scss'],
  imports: [QaiIconComponent],
})
export class SimulationTypeOptionComponent {
  readonly icon = input.required<QaiIconKind>();
  readonly title = input.required<string>();
  readonly description = input.required<string>();
  readonly bestFor = input.required<string>();

  readonly selected = output<void>();
}
